import { Button, Layout, Tag, Text } from '@loadsmart/miranda-react'

import { Icon } from 'core/ui/components/icon/Icon'

import { formatBidButtonLabel, formatBulkSpotQuoteItemTitle } from '../presenter/spotQuotePresenter'
import { BulkSpotQuoteTags } from './BulkSpotQuoteTags'
import { SpotQuoteBidDeadline } from './SpotQuoteBidDeadline'
import { type SpotQuoteCardProps } from './SpotQuoteCard'
import { BodyWrapper, CardWrapper, DeadlineWrapper } from './SpotQuoteCard.styles'

export function BulkSpotQuoteMobileCard({
  expiredQuote,
  item,
  showDeadline,
  onBidClick,
}: SpotQuoteCardProps) {
  const { lanes, isUnderNegotiation } = item
  const { soonestBidDeadline } = lanes

  return (
    <CardWrapper>
      {showDeadline && (
        <DeadlineWrapper>
          <SpotQuoteBidDeadline
            deadline={soonestBidDeadline}
            isExpired={expiredQuote}
            isMultiline
            isBulkQuote
          />
        </DeadlineWrapper>
      )}
      <BodyWrapper>
        {isUnderNegotiation && (
          <Tag variant="warning" leading={<Icon name="attention" />}>
            Counter-offer received
          </Tag>
        )}
        <Layout.Stack gap="spacing-2">
          <Text variant="heading-sm-bold">{formatBulkSpotQuoteItemTitle(lanes)}</Text>
          <BulkSpotQuoteTags item={item} />
        </Layout.Stack>
        <Button type="button" variant="secondary" onClick={onBidClick}>
          {formatBidButtonLabel({ isUnderNegotiation, isBulkQuote: true })}
        </Button>
      </BodyWrapper>
    </CardWrapper>
  )
}
